import applicationTilesEqualHeight from "../ApplicationTiles/applicationTilesEqualHeight";

export default function initAccordion() {
  const accordionEls = document.querySelectorAll(".js-accordion");

  if (accordionEls) {
    accordionEls.forEach((el, i) => {
      const accordionButtons = el.querySelectorAll(".accordion__title");
      const buttonIcons = el.querySelectorAll(".accordion__title-control");
      const accordionPanels = el.querySelectorAll(".accordion__panel");

      // Add a click event handler to each individual accordion within a group
      for (let i = 0; i < accordionButtons.length; i++) {
        accordionButtons[i].addEventListener("click", () => {
          // Set aria attributes
          if (accordionButtons[i].getAttribute("aria-expanded") === "false") {
            accordionButtons[i].setAttribute("aria-expanded", "true");
          } else {
            accordionButtons[i].setAttribute("aria-expanded", "false");
          }

          // Set display of the accordion panel and "+" and "x" buttons
          accordionPanels[i].style.display =
            accordionPanels[i].style.display === "block" ? "none" : "block";
          buttonIcons[i].innerHTML =
            accordionPanels[i].style.display === "block"
              ? `<svg
            className="accordion__title-control-close"
            preserveAspectRatio="none"
            viewBox="0 0 20 20"
            width="20"
            height="20"
            fill="none"
            stroke="#333333"
            stroke-width="2"
            xmlns="http://www.w3.org/2000/svg"
            >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
              stroke="#333333"
              stroke-width="2"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
              stroke="#333333"
              stroke-width="2"
            />
            </svg>`
              : `<svg
            preserveAspectRatio="none"
            viewBox="0 0 20 20"
            width="20"
            height="20"
            fill="none"
            stroke="#333333"
            stroke-width="2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="2"
              y1="10"
              x2="18"
              y2="10"
              stroke="#333333"
              stroke-width="2"
            />
            <line
              x1="10"
              y1="2"
              x2="10"
              y2="18"
              stroke="#333333"
              stroke-width="2"
            />
          </svg>`;

          // Run equal height script(s)
          if (accordionPanels[i].querySelector(".application-tiles")) {
            applicationTilesEqualHeight();
          }
        });
      }
    });
  }
}
